module.exports = __webpack_public_path__ + "static/media/exhibition-services-img12.f505f455.jpg";